
<div [ngClass]="{'container-fluid': fullWidthView$ | async, 'container': !(fullWidthView$ | async)}">
  <div class="row justify-content-start align-items-start">
    <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12" id="js-duration-target">

        <!-- title and top button -->
        <div class="row " *ngIf="hasLines" >
          <div class="col-md-6">
              <h1>{{ 'checkout.title' | translate }}</h1>
              <p class="aantalartikelen" *ngIf="hasLines">
                {{ order.lines.length }} <span *ngIf="order.lines.length != 1">{{ 'checkout.articles' | translate }}</span><span *ngIf="order.lines.length == 1">{{ 'checkout.article' | translate }}</span> {{ 'checkout.articlesfound' | translate }}.
              </p>
          </div>
        </div>

         <!-- no items -->
         <div class="row" *ngIf="!hasLines">
          <div class="col-md-12">
            <h1>{{ 'checkout.title' | translate }}</h1>
            <p style="margin-top: 15px;">
                {{ 'checkout.cart-empty' | translate }}
            </p>
          </div>
        </div>

        <!-- cart -->
        <div class="row" *ngIf="hasLines">

          <div class="col-md-12">

            <app-cart-table editable="true"
                            [order]="order"
                            [currency]="currency"
                            [showDeliveryColumn]="showDeliveryColumn"
                            [quantityPicker]="quantityPicker"
                            [showUomInfoForUoms]="checkoutPageSettings?.showUomInfoForUoms"
                            [showFacets]="checkoutPageSettings?.showFacets"
                            [backordercounts]="backordercounts"
                            [discountType]="discountType"
                            [extraCosts]="extraCosts"
                            (onDetails)="openDetails($event)"
                            (onLineChange)="changeLine($event)"
                            (onLineDelete)="deleteLine($event)">
            </app-cart-table>
          </div>

        </div>

        <!-- back and continue -->
        <div class="row row-back">
          <div class="col-md-12">
            <button (click)="goBack()" class="btn btn-back" tabindex="-1"><i class="fa fa-arrow-left"></i>{{ 'details.back-button' | translate }}</button>
          </div>
        </div>

    </div>
    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 " *ngIf="hasLines">
      <form [formGroup]="checkoutForm" class="orderform" id="js-sliding-form">

        <div class="row">
          <div class="col-md-12">
            <h3 class="with-line no-top-margin">{{ 'checkout.delivery-address' | translate }} </h3>

            <div class="delivery-address" [ngClass]="{ 'delivery-address-multiple': addresses.length > 1 }">
              <app-addresses [addresses]="addresses"
                             [current]="deliveryAddressNumber"
                             (addressChanged)="setAddress('delivery', $event)">
              </app-addresses>
              <span class="text-danger form-error" *ngIf="formGroupDir?.submitted && !deliveryAddress && !committing">
                {{ 'validation.required' | translate: {field: 'checkout.delivery-address' | translate} }}
              </span>
            </div>

            <h3 class="with-line">{{ 'checkout.delivery-date' | translate }} </h3>

            <app-date-picker
              formControlName="dlvDate"
              tabindex="1"
              [deliveryDateMode]="checkoutPageSettings?.deliveryDateMode"
              [ngClass]="{'submitted': formGroupDir?.submitted}"
              [deliverydates]="deliverydates">
            </app-date-picker>

            <span class="text-danger form-error" *ngIf="isFieldValid('dlvDate')">
              {{ 'checkout.delivery-date-validate' | translate }}
            </span>

          </div>
          <div class="col-md-12">

            <!-- reference -->
            <h3 class="with-line">{{ 'checkout.reference-title' | translate }} </h3>
            <input
              placeholder=""
              id="order-reference"
              class="form-control reference"
              [maxlength]="customerReferenceMaxLength"
              formControlName="customerReference"
              tabindex="2" />
            <span class="legend">
              {{ 'validation.maxlength' | translate:customerReferenceMaxLengthParam }}
            </span>

            <!-- remarks -->
            <h3 class="with-line">{{ 'checkout.remarks' | translate }} </h3>
            <textarea
              class="form-control remarks"
              formControlName="comments"
              placeholder=""
              tabindex="3"></textarea>
            <!-- <i class="fa fa-pencil" aria-hidden="true"></i> -->

            <!-- ORDER TYPE -->
            <h3 class="with-line" *ngIf="checkoutPageSettings?.showOrderType">Order type </h3>
            <div class="ordertype" *ngIf="checkoutPageSettings?.showOrderType">
              <div class="form-group">
                <input id="order" type="radio" value="Order" formControlName="type" name="type" tabindex="4">
                <label for="order">Order</label>
              </div>
              <div class="form-group">
                <input id="offerte" type="radio" value="Offerte" formControlName="type" name="type" tabindex="5">
                <label for="offerte">Offerte</label>
              </div>
              <span class="text-danger form-error" *ngIf="isFieldValid('type')">
                {{ 'validation.required' | translate: {field: 'type'} }}
              </span>
            </div>

            <!-- TERMS & CONDITIONS -->
            <!-- SK: 21/01/2019 - configure in checkout page setting -->
            <div class="terms-and-conditions-wrapper" *ngIf="checkoutPageSettings?.showTermsAndConditionsCheckbox">
              <h3 class="with-line">{{ 'checkout.termsandconditions' | translate }}</h3>
              <div class="form-group terms">
                <input
                  type="checkbox"
                  id="terms"
                  class="form-control"
                  formControlName="terms"
                  tabindex="6">
                <label for="terms">{{ 'checkout.termsandconditionsagree' | translate | splitTranslation:0 }} <a href="javascript:void(0)" (click)="openModal(content)" class="agreeterms">{{ 'checkout.termsandconditionsagree' | translate | splitTranslation:1 }}</a></label>
              </div>
              <span class="text-danger form-error" *ngIf="isFieldValid('terms')">
                {{ 'validation.required' | translate: {field: 'checkout.termsandconditions' | translate | lowercase }  }}
              </span>
            </div>

          </div>
          <div class="col-12">

            <app-form-error [error]="errors"></app-form-error>

            <div *ngIf="!minOrderValueReached" class="alert alert-warning alert-with-icon min-order-value">
              <i class="fa fa-exclamation-triangle"></i>
              <span class="text">{{ 'checkout.validation.minordervalue' | translate: { minOrderValue: minOrderValueFormatted } }} </span>
            </div>

          </div>
        </div>

        <!-- back and place order -->
        <div class="row row-place-order" *ngIf="hasLines && minOrderValueReached">
          <div class="col-md-12 text-left place-order">
            <button type="submit" appDebounceClick class="btn btn-success btn-icon-right btn-order" [formSubmissions]="formSubmissions" (debounceClick)="submit()" tabindex="7">
              {{ 'checkout.submit-order' | translate }} <i class="fa fa-arrow-right"></i>
            </button>
          </div>
        </div>

         <!-- disclaimer -->
        <p *ngIf="hasLines" class="disclaimer">
            {{ 'checkout.disclaimer' | translate }}
        </p>


      </form>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title"></h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <!-- changes object to iframe for IE -->
  <div class="modal-body">
    <iframe [src]="'checkout.termsandconditionslink' | translate | safeUrl" width="100%" height="100%">
      <p>{{ 'browserpdfsupport' | translate }}</p>
      <a [href]="'checkout.termsandconditionslink' | translate | safeUrl" target="_blank">{{ 'download' | translate }}</a>
    </iframe>
  </div>

</ng-template>
